import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from 'src/app/services/api/common.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { VideoPlayerComponent } from '../../../shared/video-player/video-player.component';
import { NgClass, NgIf, NgFor, CommonModule } from '@angular/common';
import { SchoolData } from 'src/app/models/schoolUser';
import { SubjectChipsComponent } from 'src/app/shared-module/subject-chips/subject-chips.component';
@Component({
  selector: 'app-public-school',
  templateUrl: './public-school.component.html',
  styleUrls: ['./public-school.component.scss'],
  imports: [VideoPlayerComponent, NgIf, SubjectChipsComponent],
  standalone: true
})
export class PublicSchoolComponent implements OnInit {

  schoolLogo: any;
  schoolName: any;
  profileData: any;
  mapsUrl: any;
  recentJobsList: any;
  introVideo: any = null;
  public schoolProps!: SchoolData;
  from: any;

  constructor(
    private ngxService: NgxUiLoaderService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private authService: AuthenticationService,
  ) { }
  get isAuthenticated(): boolean {
    return this.authService.isLoggedIn();
  }
  // Helper: parse YouTube ID
  private getYouTubeId(url: string): string | null {
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:shorts\/|embed\/|v\/|live\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
    return match ? match[1] : null;
  }

  // Helper: parse Vimeo ID
  private getVimeoId(url: string): string | null {
    const match = url.match(/(?:vimeo\.com\/(?:video\/)?)(\d+)/);
    return match ? match[1] : null;
  }
  ngOnInit(): void {
    this.ngxService.start();
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    this.route.params.subscribe(params => {
      this.schoolName = params['slugName'];
    });
    this.route.queryParams.subscribe(query => {
      this.from = query['from'];
    });
    this.commonService.publicSchool(this.schoolName).subscribe({
      next: (res: any) => {
        if (res.status) {
          // this.overview = res.data.overview.replace(/\n/g, '<br/>');
          this.profileData = res.data;
          this.recentJobsList = res?.data?.recent_job;
          this.initMap();

          let videoUrl = 'https://maps.google.com/maps?q=' + this.profileData.location.lat + ',' + this.profileData.location.lng + '&z=15&&output=embed'
          // this.mapsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl)
          this.schoolLogo = res.data.additional_info?.profile_image;
          const videoIntroDetails = res.data.additional_info.school_video_intro_details;

          if (videoIntroDetails?.video_intro_link) {
            const ytId = this.getYouTubeId(videoIntroDetails.video_intro_link);
            if (ytId) {
              this.introVideo = {
                type: 'youtube',
                id: ytId,
                url: videoIntroDetails.video_intro_link,
                title: videoIntroDetails.video_intro_title || '',
                thumbnail: videoIntroDetails.video_intro_thumbnail || '',
                duration: videoIntroDetails.video_intro_duration || null,
              };
            } else {
              // Could add Vimeo support here if needed
              const vimeoId = this.getVimeoId(videoIntroDetails.video_intro_link);
              if (vimeoId) {
                this.introVideo = {
                  type: 'vimeo',
                  id: vimeoId,
                  url: videoIntroDetails.video_intro_link,
                  title: videoIntroDetails.video_intro_title || '',
                  thumbnail: videoIntroDetails.video_intro_thumbnail || '',
                  duration: videoIntroDetails.video_intro_duration || null,
                };
              } else {
                this.introVideo = null;
              }
            }
          } else {
            this.introVideo = null;
          }
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message || 'Failed to fetch school profile');
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        // this.toastr.error(err.message)
        this.ngxService.stop();
        console.log(err);
      }
    })
  }
  openPublicJobs(id: any) {
    window.open(environment.apiUrl + "jobs/view-job/" + id, "_blank");
  }
  map!: google.maps.Map;
  initMap() {
    const lat = this.profileData.location.lat;
    const lng = this.profileData.location.lng;

    const location = { lat, lng };

    const mapElement = document.getElementById('map') as HTMLElement;

    this.map = new google.maps.Map(mapElement, {
      center: location,
      zoom: 15
    });

    const marker = new google.maps.Marker({
      position: location,
      map: this.map
    });

    const infoWindow = new google.maps.InfoWindow({
      content: `
      <div>
        <p>${this.profileData.title}</p>
        <p>${this.profileData.address.city}, ${this.profileData.address.address_timezone.state}</p>
        <a href="https://www.google.com/maps/search/?api=1&query=${lat},${lng}" target="_blank">
          View on Map
        </a>
      </div>
    `
    });

    marker.addListener('click', () => {
      infoWindow.open(this.map, marker);
    });
  }
}
